import IAARAddressDTO from "@/dto/request/iaar/IAARAddressDTO";

export default class PublicPersonNotValidPayload {

    currentIsValid = false;
    correctedAddress = new IAARAddressDTO();

}
